import { AxiosError } from 'axios';

import { LEADS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { CreateLeadPayload } from '@/types/lead.type';
import { ApiResponse } from '@/types/response.type';

export type LeadResponse = {
  id: string;
  zor_id: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  email: string;
  phone?: string;
  photo_url?: string;
  birth_date?: string;
  address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  linkedin?: string;
  meeting_link?: string;
  preferred_markets?: string[];
  source?: string;
  status?: string;
  converted_to_zee_id?: string;
  converted_at?: string;
  created_at: string;
  updated_at: string;
};

const createLead = async (
  payload: CreateLeadPayload
): Promise<ApiResponse<LeadResponse>> => {
  try {
    const response = await apiManager.post(LEADS_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default createLead;
